module.exports = __webpack_public_path__ + "static/moonlitNightMoreModern3Arranged-a9eb6e4ab2bcb28f1dccfd70c46000b3.mp3";